{
  "_comment": "[CI-LOCKED] Šio failo turinys užrakintas. Galite prisidėti, tačiau gali užtrukti, kol keitimai bus patikrinti.",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "Robotas $1 pasakė:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Agentas",
  "ACTIVITY_YOU_SAID_ALT": "Pasakėte:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Robotas pridėjo:",
  "ACTIVITY_CODE_ALT": "Kodo pavyzdys: $1",
  "ACTIVITY_CONTENT_CAUTION": "Dirbtinio intelekto sugeneruotas turinys gali būti neteisingas",
  "ACTIVITY_CODE_CAUTION": "DI sugeneruotas kodas. Patikrinkite ir naudokite apdairiai",
  "ACTIVITY_ERROR_BOX_TITLE": "Klaidos pranešimas",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Spustelėkite norėdami sąveikauti.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "Pranešimas yra interaktyvus.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Pranešime yra vienas ar keli saitai.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Išsiųsti nepavyko.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Pridėjote:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 priedą.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 priedus.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 priedų.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 priedus.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 priedus.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Nepavyko išsiųsti. [Bandyti dar kartą][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Siunčiama",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Išsiųsta $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Ką tik",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Prieš valandą",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Prieš minutę",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Šiandien",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Vakar",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Adaptyviosios kortelės analizės klaida",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Adaptyviosios kortelės atvaizdavimo klaida",
  "ATTACHMENT_AUDIO": "Garso įrašas.",
  "ATTACHMENT_CARD": "Kortelė: $1 $2 $3",
  "ATTACHMENT_FILE": "Failas: $1",
  "ATTACHMENT_IMAGE": "Vaizdas",
  "ATTACHMENT_TEXT": "Teksto žinutė: $1",
  "ATTACHMENT_VIDEO": "Vaizdo įrašas",
  "AVATAR_ALT": "$1 pseudoportretas",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Pirmyn",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Atgal",
  "CITATION_MODEL_DIALOG_ALT": "Citata",
  "CLOSE_BUTTON_ALT": "Uždaryti",
  "COLLAPSIBLE_GROUPING_TITLE": "Galvoju…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Taip rodoma, kai robotas kuria atsakymus grupėje, jei nepateikta santrauka.",
  "COLLAPSE_BUTTON_LESS": "Rodyti mažiau",
  "COLLAPSE_BUTTON_LESS.comment": "Tai ševrono mygtuko tekstas, skirtas sutraukti pranešimų grupę. Kai galutinis vartotojas spustelėja mygtuką, pranešimų grupė sutraukiama.",
  "COLLAPSE_BUTTON_MORE": "Rodyti daugiau",
  "COLLAPSE_BUTTON_MORE.comment": "Tai ševrono mygtuko tekstas, skirtas išplėsti pranešimų grupę. Kai galutinis vartotojas spustelėja mygtuką, pranešimų grupė išplečiama.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Prijungta",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Jungiamasi…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Nepavyko prijungti.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Nutrūko tinklo ryšys. Jungiamasi iš naujo...",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Atvaizdavimo klaida. Patikrinkite konsolę arba kreipkitės į roboto kūrėją.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Prisijungimas trunka ilgiau nei įprasta.",
  "CONNECTIVITY_STATUS_ALT": "Ryšio būsena: $1",
  "COPY_BUTTON_TEXT": "Kopijuoti",
  "COPY_BUTTON_COPIED_TEXT": "Nukopijuota",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Pateikti",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Atšaukti",
  "FEEDBACK_FORM_PLACEHOLDER": "Pateikite kuo daugiau informacijos, tačiau neįtraukite jokios privačios ar neskelbtinos informacijos.",
  "FEEDBACK_FORM_TITLE": "Papasakokite apie savo patirtį",
  "FILE_CONTENT_ALT": "$1",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Atsisiųsti failą $1",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Atsisiųsti failą $1, kurio dydis $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "$1, kurio dydis $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Atidaroma naujame lange; išorinis.",
  "RECEIPT_CARD_TAX": "Mokestis",
  "RECEIPT_CARD_TOTAL": "Iš viso",
  "RECEIPT_CARD_VAT": "PVM",
  "REFERENCE_LIST_HEADER_ONE": "$1 nuoroda",
  "REFERENCE_LIST_HEADER_FEW": "$1 nuorodos",
  "REFERENCE_LIST_HEADER_MANY": "$1 nuorodos",
  "REFERENCE_LIST_HEADER_OTHER": "$1 nuorodų",
  "REFERENCE_LIST_HEADER_TWO": "$1 nuorodos",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Panaikinti priedą $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Naikinti",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Failas",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Vaizdas",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Negali siųsti tuščio pranešimo.",
  "SPEECH_INPUT_LISTENING": "Klausomasi…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Mikrofonas išjungtas",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Mikrofonas įjungtas",
  "SPEECH_INPUT_STARTING": "Pradedama…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Pirmyn",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Atgal",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Siūlomi veiksmai",
  "TEXT_INPUT_ALT": "Pranešimo įvedimo laukas",
  "TEXT_INPUT_PLACEHOLDER": "Įveskite savo pranešimą",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Pradėkite kalbėti...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Klausoma...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Apdorojama...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Kalbėkite, kad pertrauktumėte...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Siųsti",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Kalbėti",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Nusiųsti failą",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Telefono klaviatūra",
  "TEXT_INPUT_DROP_ZONE": "Nuvilkite failus",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Viršytas pranešimo ilgis",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Palaiko tik vieno skaitmens įvestį",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 priedai",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 priedo",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 priedas",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 priedų",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 priedai",
  "TOAST_ACCORDION_FEW": "Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją",
  "TOAST_ACCORDION_MANY": "Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją",
  "TOAST_ACCORDION_OTHER": "Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją",
  "TOAST_ACCORDION_TWO": "Pranešimų: $1. Spustelėkite čia, kad pamatytumėte išsamesnę informaciją",
  "TOAST_ALT_ERROR": "Klaida",
  "TOAST_ALT_INFO": "Informacija",
  "TOAST_ALT_SUCCESS": "Sėkmingai",
  "TOAST_ALT_WARN": "Įspėjimas",
  "TOAST_DISMISS_BUTTON": "Išjungti",
  "TOAST_TITLE_ALT": "Pranešimas",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Pokalbio retrospektyva, naršykite naudodami rodyklių klavišus.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "pokalbio retrospektyva",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Pranešimas yra interaktyvus. Norėdami perjungti į pokalbio retrospektyvą, 2–3 kartus paspauskite klavišą „Shift“ ir tabuliavimo klavišą. Tada spustelėkite pranešimą, kad sąveikautumėte.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Pranešime yra vienas ar keli saitai. Norėdami perjungti į pokalbio retrospektyvą, 2–3 kartus paspauskite klavišą „Shift“ ir tabuliavimo klavišą. Tada spustelėkite pranešimą, kad sąveikautumėte.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "Pranešime siūlomi veiksmai. Norėdami juos pasirinkti, 2–3 kartus paspauskite klavišą „Shift“.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "Pranešime siūlomi veiksmai. Norėdami juos pasirinkti, paspauskite klavišą $1.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Nepavyko išsiųsti pranešimo.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Yra naujų pranešimų. Paspauskite $1, jei norite aktyvinti mygtuką „$2“.",
  "TRANSCRIPT_MORE_MESSAGES": "Daugiau pranešimų",
  "TRANSCRIPT_NEW_MESSAGES": "Nauji pranešimai",
  "TRANSCRIPT_TERMINATOR_TEXT": "Pokalbio retrospektyvos pabaiga",
  "TYPING_INDICATOR_ALT": "Rodomas teksto įvedimo indikatorius",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 rašo.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "Rašo $1 ir kiti.",
  "VIEW_CODE_BUTTON_TEXT": "Kodas",
  "VOTE_COMPLETE_ALT": "Atsiliepimas įrašytas",
  "VOTE_COMPLETE_ALT.comment": "Tai skirta ekrano skaitytuvams. Mygtuko etiketė su nykščio aukštyn / žemyn piktograma. Etiketė naudojama, kai atsiliepimas įrašomas.",
  "VOTE_DISLIKE_ALT": "Nepatinka",
  "VOTE_LIKE_ALT": "Patinka"
}